var C = Object.defineProperty;
var z = (s, t, e) => t in s ? C(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var f = (s, t, e) => (z(s, typeof t != "symbol" ? t + "" : t, e), e);
import "../../index83.css";
import { jsxs as k, jsx as m } from "react/jsx-runtime";
import { ChevronLeftLineIcon as P, ChevronRightLineIcon as N } from "@ifrc-go/icons";
import { i as w } from "../../type-BFTbooL7.js";
import { _ } from "../../cs-piwRuCFZ.js";
import x from "../RawButton/index.js";
import $ from "../../hooks/useTranslation.js";
const T = "common", v = {
  rawButtonGoTo: "Go to",
  rawButtonGoToPage: "Go to page"
}, G = {
  namespace: T,
  strings: v
}, L = "_pager_83zz4_1", S = "_page-list_83zz4_2", I = "_page-button_83zz4_7", M = "_active_83zz4_15", j = "_compact_83zz4_21", A = "_icon_83zz4_30", i = {
  pager: L,
  pageList: S,
  pageButton: I,
  active: M,
  compact: j,
  icon: A
};
function y(s, t) {
  const e = [];
  for (let c = s; c <= t; c += 1)
    e.push(c);
  return e;
}
class B {
  constructor(t, e) {
    f(this, "capacity");
    f(this, "demand");
    f(this, "excess");
    this.capacity = t, this.demand = e, this.excess = this.capacity - this.demand;
  }
  hasShortage() {
    return this.excess < 0;
  }
  increaseCapacity(t) {
    this.capacity += t, this.excess += t;
  }
  decreaseCapacity(t) {
    this.capacity += t, this.excess += t;
  }
  optimizeCapacity() {
    this.excess > 0 && (this.capacity -= this.excess, this.excess = 0);
  }
}
function E(s, t, e, c = !1) {
  if (c)
    return y(1, e).map((a) => a === t ? { type: "fakeButton", label: String(t), key: "active" } : { type: "button", index: a });
  const g = (s - 1) / 2, d = 1, u = e, o = new B(g, t - d), r = new B(g, u - t), h = r.excess, p = o.excess;
  o.hasShortage() && h > 0 ? o.increaseCapacity(h) : r.hasShortage() && o.excess > 0 && r.increaseCapacity(p), r.optimizeCapacity(), o.optimizeCapacity();
  const l = [];
  return o.capacity > 0 && (o.excess >= 0 ? l.push(
    ...y(d, t - 1).map((a) => ({ type: "button", index: a }))
  ) : l.push(
    { type: "button", index: d },
    { type: "span", label: "…", key: "startTick" },
    ...y(t - (o.capacity - 2), t - 1).map((a) => ({ type: "button", index: a }))
  )), l.push(
    { type: "fakeButton", label: String(t), key: "active" }
  ), r.capacity > 0 && (r.excess >= 0 ? l.push(
    ...y(t + 1, u).map((a) => ({ type: "button", index: a }))
  ) : l.push(
    ...y(t + 1, t + (r.capacity - 2)).map((a) => ({ type: "button", index: a })),
    { type: "span", label: "...", key: "endTick" },
    { type: "button", index: u }
  )), l;
}
function Q(s) {
  const {
    activePage: t,
    className: e,
    disabled: c = !1,
    itemsCount: g,
    maxItemsPerPage: d = 25,
    onActivePageChange: u,
    showAllPages: o = !1,
    totalCapacity: r = 7
  } = s, h = $(G), p = Math.max(t, 1), l = Math.max(Math.ceil(g / d), 1), a = E(r, p, l, o), b = a.length > 1 ? /* @__PURE__ */ k("div", { className: i.pageList, children: [
    /* @__PURE__ */ m(
      x,
      {
        name: p - 1,
        onClick: u,
        className: i.pageButton,
        disabled: p <= 1 || c,
        title: `${h.rawButtonGoToPage} ${p - 1}`,
        children: /* @__PURE__ */ m(P, { className: i.icon })
      }
    ),
    a.map((n) => n.type === "button" ? /* @__PURE__ */ m(
      x,
      {
        className: i.pageButton,
        name: n.index,
        onClick: u,
        disabled: c,
        title: `${h.rawButtonGoTo} ${n.index}`,
        children: n.index
      },
      `button-${n.index}`
    ) : n.type === "fakeButton" ? /* @__PURE__ */ m(
      x,
      {
        name: void 0,
        className: _(
          i.pageButton,
          i.active,
          n.label.length > 2 && i.compact
        ),
        children: n.label
      },
      `button-${n.key}`
    ) : /* @__PURE__ */ m(
      "div",
      {
        className: i.pageButton,
        children: n.label
      },
      `span-${n.key}`
    )),
    /* @__PURE__ */ m(
      x,
      {
        name: p + 1,
        onClick: u,
        disabled: p >= l || c,
        className: i.pageButton,
        title: `${h.rawButtonGoToPage} ${p - 1}`,
        children: /* @__PURE__ */ m(N, { className: i.icon })
      }
    )
  ] }) : void 0;
  return w(b) ? null : /* @__PURE__ */ m("div", { className: _(e, i.pager), children: b });
}
export {
  Q as default
};
